import { ENCRYPT_STORAGE, SET_STARTUP, WebWidth } from "../../config/config";
import { STORE_HardReleaseVersion } from "../../database/store-names";
import { PT_SETTINGS, PT_STARTUP } from "../../routes/stack/paths/pt-home";
import { get_Href_URL_Params } from "../../functions/funtion";
import { REQUEST_PUSHTOKEN } from "../../functions/mobile-intigrator";
import { dto_Customer } from "../../classes/dto-customer";
import React from "react";

export default class Configure extends React.Component {
  state = {
    isLoading: true,
  };

  buildStartupPath = (csp, hardReleaseVersion) => {
    const currentSearch = String(window.location.search || "");
    const hasQrSearch =
      currentSearch.startsWith("?QR?") || currentSearch.includes("mode=QR");
    const startupBasePath = PT_STARTUP.replace(":csp", csp);

    if (hasQrSearch) {
      return `${startupBasePath}${currentSearch}`;
    }

    const hasVersion =
      hardReleaseVersion !== undefined &&
      hardReleaseVersion !== null &&
      hardReleaseVersion !== "" &&
      hardReleaseVersion !== "undefined";

    const startupPath = hasVersion
      ? `${startupBasePath}?ver=${hardReleaseVersion}`
      : startupBasePath;

    return startupPath;
  };

  async componentDidMount() {
    let { csp } = this.props.params;
    let HardReleaseVersion = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
    await REQUEST_PUSHTOKEN();
    await SET_STARTUP({ csp: csp, HardReleaseVersion: HardReleaseVersion });

    this.setState({ isLoading: false });

    setTimeout(() => {
      if (dto_Customer.CSID !== 18755100) {
        const startupPath = this.buildStartupPath(csp, HardReleaseVersion);
        this.props.navigate(startupPath);
      }
    }, 0.00001);
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div
          className="loader"
          style={{ marginTop: "90%", marginLeft: "45%" }}
        />
      );
    }

    return (
      <div
        style={{
          width: WebWidth,
          height: "100%",
          backgroundColor: "#f0f0f0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            width: "150px",
            margin: "10px",
            padding: "10px",
            backgroundColor: "#3498db",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            this.props.navigate(PT_SETTINGS);
          }}
        >
          Go To Settings
        </button>

        <br />

        <button
          style={{
            width: "150px",
            margin: "10px",
            padding: "10px",
            backgroundColor: "#2ecc71",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            let { csp } = this.props.params;
            let HardReleaseVersion = get_Href_URL_Params().ver;
            const startupPath = this.buildStartupPath(csp, HardReleaseVersion);
            this.props.navigate(startupPath);
          }}
        >
          Go To App
        </button>
      </div>
    );
  }
}
